import { CertificationsDto   } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
export class CertificationResponseModel extends GlobalResponseObject{
    data?: CertificationsDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //CertificationsDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: CertificationsDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 